
export default function PrintIcon() {
  return (
    <svg
      width="26"
      height="33"
      viewBox="0 0 34 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 0.863281V28.8377C1 30.767 2.66667 31.5709 3.5 31.7316H30C26 31.7316 26.5 29.32 26.5 28.3554V0.863281H1Z"
        stroke="black"
        stroke-width="1.5"
      />
      <path
        d="M26.5 5.2041H32.5V29.8023C32.5 30.4454 31.8 31.7316 29 31.7316"
        stroke="black"
        stroke-width="1.5"
      />
      <rect
        x="3.75"
        y="4.50684"
        width="11.5"
        height="9.111"
        stroke="black"
        stroke-width="1.5"
      />
      <rect
        x="3.75"
        y="18.9766"
        width="11.5"
        height="9.111"
        stroke="black"
        stroke-width="1.5"
      />
      <path d="M17.5 5.68652H24" stroke="black" stroke-width="1.5" />
      <path d="M17.5 8.58057H24" stroke="black" stroke-width="1.5" />
      <path d="M17.5 11.4746H24" stroke="black" stroke-width="1.5" />
      <path d="M17.5 20.1558H24" stroke="black" stroke-width="1.5" />
      <path d="M17.5 23.0498H24" stroke="black" stroke-width="1.5" />
      <path d="M17.5 25.9438H24" stroke="black" stroke-width="1.5" />
    </svg>
  );
}
